export default __webpack_public_path__ + "static/media/coupons.94b971a8.png";